import { Component, OnInit, OnDestroy } from '@angular/core';
import { PershingTranslationService, INavigationService } from '@pershing/pershing-core';
import { NxiNavigation } from '@pershing/nxi-common';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'secondlevel-navigation',
    templateUrl: 'secondlevel-navigation.component.html'
})

export class SecondLevelNavigationComponent implements OnDestroy, OnInit {
    secondNavLinks: any[];
    selectedPageId: string;
    selectedPage: any;
    navigation: NxiNavigation;
    showSecondNav: boolean;
    titleValueArray: string[];
    titleValue: string;
    constructor(private translationService: PershingTranslationService, private navigationService: INavigationService, private route: ActivatedRoute) {
        this.translationService.addTranslationFolder('@pershing/nxi-navigation', 'node_modules/@pershing/nxi-navigation/lib');
        this.navigationService.getParentPage().subscribe(data => {
            if (data && data.children && data.children.length > 0) {
                // To remove financial planning from menu when theme switch or page refresh happens
                if (data.id === 'tools') {
                    data = this.handleRemoveMenu(data);
                }
                if (data.children.length > 0) {
                    this.showSecondNav = true;
                    if (data.id !== 'postlogin-security') {
                        // Do not override the navlinks. Since postlogin-security doesnt has a proper menu.
                        // If the list gets added move to constant file.
                        this.secondNavLinks = data.children;
                    }
                } else {
                    this.showSecondNav = false;
                }
            } else {
                this.showSecondNav = false;
            }
        });
        this.navigationService.getChildPage().subscribe(childpage => {
            if (childpage) {
                this.selectedPageId = childpage.id;
            }
        });
    }

    handleChildNavigation(childPage): void {
        this.navigation = new NxiNavigation();
        // this.selectedPageId = childPage.id;
        // this.navigation.parentPage = this.selectedPage;
        this.navigation.childPage = childPage;
        this.navigationService.handleNavigation(this.navigation);
    }
    handleRemoveMenu(data: any) {
        if (data.children.length > 0) {
            let finPlanID = 'financialplanning';
            if (data.children.filter(item => finPlanID === item.id).length > 0
                && !!sessionStorage.getItem('rmvFinPlan') && sessionStorage.getItem('rmvFinPlan') === 'Y') {
                data.children = data.children.filter(item => !finPlanID.includes(item.id));
                return data;
            }
        }
        return data;
    }
    ngOnInit() {
        console.log(' In Component OnInit ');
    }
    public ngOnDestroy() {
        console.log(' In Component Destroy ');
    }

}
